import React from 'react';
import PropTypes from 'prop-types';
import { MFELoader } from '@jarvis/react-portal-addons';
import { getModuleInitializedEvent, publishEvent } from '../../../utils/analytics';

const MFE_REFS = {
  NOTIFICATION: '@jarvis/react-smb-notifications',
};

const NotificationsWidget = ({
  stack, properties,
}) => (
  <MFELoader
    analytics={{
      enable: true,
      events: {
        moduleDisplayed: {
          activity: 'Home-v01',
        },
      },
    }}
    card
    component={MFE_REFS.NOTIFICATION}
    data-testid="smart-notification-widget-mfe"
    header={false}
    onLoad={() => {
      publishEvent(getModuleInitializedEvent('ReactSmbNotifications'));
    }}
    properties={properties}
    stack={stack}
    type="ConsolidatedSmartNotification"
  />
);

NotificationsWidget.defaultProps = {
  stack: 0,
  properties: {},
};

NotificationsWidget.propTypes = {
  stack: PropTypes.number,
  properties: PropTypes.objectOf(PropTypes.any),
};

export default NotificationsWidget;
